<template>
	<div class="pages">
		<sub-ibox-title>
			<p slot="title">裂变红包</p>
		</sub-ibox-title>
		<z-tabbar :list-obj="tabbarList"></z-tabbar>
		<section>
			<transition name="fade" mode="out-in">
				<router-view class="view"></router-view>
			</transition>
		</section>
	</div>
</template>
<script>
	export default {
		name: 'Red_pack',
		data() {
			return {
				tabbarList: [{
					title: '红包列表',
					routeName: 'redPacketList'
				}, {
					title: '红包统计',
					routeName: 'redPacketCount'
				}, {
					title: '使用记录',
					routeName: 'redPacketRecord'
				}]
			}
		}
	}
</script>


// WEBPACK FOOTER //
// Index.vue?3bbcdd48